// bao migrate skip
import "./../factories/tree-node";
import "./../bindings/bao-tree";
import "./../bindings/bao-template";
import "./../bindings/bao-pager";
import "./../bindings/filtering";
import "./../services/bao-utils";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import baoRouter from "./../services/bao-router";
import AppTabController from "../services/app-tab-controller";
import TreeNodeViewModel from "../factories/tree-node";
import BaoUtils from "../services/bao-utils";

class DashboardViewModel {
    Bao = Bao;
    //observables
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    SelectedNode = ko.observable<{
        CustomFilter: KnockoutObservable<any>;
        Id: KnockoutObservable<string>;
        Key: KnockoutObservable<string>;
    }>();
    DashboardId = ko.observable();
    DashboardLayouts = ko.observableArray();
    Models = ko.observableArray();
    LayoutId = ko.observable(null);
    SelectedRow = ko.observable<{
        OpenUrl: string;
    }>();
    Nodes = ko.observableArray();
    Selection = ko.observableArray([]);
    SelectionMode = ko.observable('single');
    TabPage = null;
    CustomFilter = ko.observableArray([]);
    filteringFilter = ko.observable([]);
    //computed
    UniqueLayoutKey = ko.observable();
    constructor(tabPage) {
        this.TabPage = tabPage;
        //subscribes
        this.Sorting.subscribe(() => {
            this.RefreshGrid();
        });
        this.SelectedNode.subscribe(() => {
            if (this.SelectedNode() != null) {
                this.CustomFilter(ko.map.toJS(this.SelectedNode().CustomFilter()));
                if (this.DashboardId() != this.SelectedNode().Id()) {
                    this.DashboardId(this.SelectedNode().Id());
                    this.LoadLayouts();
                }
                else {
                    if (this.PageIndex() == 0) {
                        this.RefreshGrid();
                    }
                    else {
                        this.PageIndex(0);
                    }
                }
            }
        });
        this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        });
        this.LayoutId.subscribe(() => {
            if (this.LayoutId() != null) {
                this.GetLayout();
            }
        });
        this.SelectedRow.subscribe((value) => {
            if (this.SelectedRow() != null) {
                // comment out, becaus $.publish does not exists. also in origin javascript
                //if (this.SelectedRow().OpenUrl == "Ticket") {
                //    $.publish("permissionenable", { ActionKey: "ActionRouting", Enabled: true, Context: tabPage.Context() });
                //    $.publish("permissionenable", { ActionKey: "ActionClose", Enabled: true, Context: tabPage.Context() });
                //    $.publish("permissionenable", { ActionKey: "ActionOperate", Enabled: true, Context: tabPage.Context() });
                //}
                //else {
                //    $.publish("permissionenable", { ActionKey: "ActionRouting", Enabled: false, Context: tabPage.Context() });
                //    $.publish("permissionenable", { ActionKey: "ActionClose", Enabled: false, Context: tabPage.Context() });
                //    $.publish("permissionenable", { ActionKey: "ActionOperate", Enabled: false, Context: tabPage.Context() });
                //}
                this.Open(this.SelectedRow());
            }
        });
        tabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case "ActionRouting":
                    case "ActionClose":
                    case "ActionOperate":
                        this.ShowActionDialog(value.ActionKey());
                        break;
                    case "DashboardRefresh":
                        var selectedKey = null;
                        if (this.SelectedNode() != null) {
                            selectedKey = this.SelectedNode().Key();
                        }
                        this.LoadTree(selectedKey);
                        break;
                }
            }
        }));
        // throttle refreshing
        this.filteringFilter.extend({ rateLimit: { method: "notifyWhenChangesStop", timeout: 400 } });
        // trigger refreshing
        this.filteringFilter.subscribe(() => { this.RefreshGrid(); });
    }
    Reset() {
        this.UniqueLayoutKey(null);
        this.SelectedNode(null);
        this.DashboardLayouts([]);
        this.PageIndex(0);
        this.TotalRows(0);
        this.Models([]);
        this.DashboardId(null);
    }
    LoadTree(selectedKey) {
        this.TabPage.IsLoading(true);
        this.Reset();
        Bao.post("Dashboard/GetTreeNodes", (value) => {
            var arrayNodes = [];
            ko.utils.arrayForEach(value, (item) => {
                arrayNodes[arrayNodes.length] = new TreeNodeViewModel(item);
            });
            this.Nodes(arrayNodes);
            this.TabPage.IsLoading(false);
            if (selectedKey != null) {
                this.RekSelectNode(selectedKey, this.Nodes);
            }
        });
    }
    RekSelectNode(key: string, nodes) {
        if (typeof key !== "undefined" && key !== null) {
            key = key.toLowerCase();
        }
        for (var i = 0; i < nodes().length; i++) {
            if (nodes()[i].Key().toLowerCase() == key) {
                this.SelectedNode(nodes()[i]);
                return true;
            }
            if (this.RekSelectNode(key, nodes()[i].Nodes) == true) {
                return true;
            }
        }
        return false;
    }
    LoadLayouts() {
        this.TabPage.IsLoading(true);
        return Bao.post("Dashboard/GetDashboardStructureLayoutCollection", JSON.stringify({ dashboardStructureId: this.SelectedNode().Id() }), (result) => {
            this.TabPage.IsLoading(false);
            this.UniqueLayoutKey(null);
            this.PageIndex(0);
            this.TotalRows(0);
            this.Models([]);
            this.DashboardLayouts(result);
        });
    }
    RefreshGrid() {
        this.TabPage.IsLoading(true);
        Bao.post("Dashboard/Search", JSON.stringify({
            dashboardId: this.DashboardId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: this.GetCustomFilter()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.TotalRows(0);
            this.Models([]);
            if (searchResult != null && searchResult.Models != null) {
                this.Models(searchResult.Models);
                this.TotalRows(searchResult.TotalCount);
            }
        });
    }
    Open(index, item?) {
        this.TabPage.IsLoading(true);
        if (item != null) {
            window.baorequire(["Factories/TabPage"], (TabPage) => {
                var newTab = new TabPage();
                newTab.Url(item.OpenUrl);
                newTab.UrlData({ id: item.OpenData });
                newTab.ObjectId(item.OpenData);
                AppTabController.AddTab(newTab);
                this.TabPage.IsLoading(false);
            });
        }
    }
    GetLayout() {
        this.TabPage.IsLoading(true);
        return Bao.post("Dashboard/GetDashboardStrucutureLayout", JSON.stringify({ dashboardStructureLayoutId: this.LayoutId() }), (result) => {
            var layoutKey = "Dashboard" + this.LayoutId();
            Bao.Templates[layoutKey] = result;
            this.UniqueLayoutKey(layoutKey);
            this.RefreshGrid();
        });
    }
    ShowActionDialog(actionKey) {
        // dont know what this does... TicketViewModel was in origin Javascript File not defined... 
        // comment out to get a valid ts file...
        //var ticketViewModel = new TicketViewModel();
        //ticketViewModel.ShowActionDialog(actionKey, this.SelectedRow().OpenData, null, true);
    }
    SelectedKey = "";
    TabSelected() {
        var key = baoRouter.getRouteValue("key", this.TabPage);
        if (key != this.SelectedKey) {
            this.SelectedKey = key;
            this.LoadTree(key);
        }
    }
    init() {
        var title = Bao.Session.GetMessage("Dashboard");
        this.TabPage.Title(title());
        title.subscribe((value) => {
            this.TabPage.Title(title());
        });
    }
    loaded() {
        BaoMenu.permissionEnable({ ActionKey: "ActionRouting", Enabled: false, Context: this.TabPage.Context() });
        BaoMenu.permissionEnable({ ActionKey: "ActionClose", Enabled: false, Context: this.TabPage.Context() });
        BaoMenu.permissionEnable({ ActionKey: "ActionOperate", Enabled: false, Context: this.TabPage.Context() });
        this.TabPage.TabSelected = this.TabSelected;
        var key = baoRouter.getRouteValue("key", this.TabPage);
        var result = this.LoadTree(key);
        return result;
    }
    GetCustomFilter() {
        let hashObject: Array<Models.HashObject> = BaoUtils.ObjectToHashObjectArray(this.filteringFilter());
        let hashObjectCustomFilter: Array<Models.HashObject> = this.CustomFilter();
        hashObject = hashObject.concat(hashObjectCustomFilter);
        return hashObject;
    }
}
export default DashboardViewModel;